<template>
    <div
        v-if="isVisible"
        class="enhancement-banner ppv2-flex ppv2-items-center ppv2-justify-between ppv2-p-4 ppv2-rounded-xl ppv2-mb-6 ppv2-relative ppv2-overflow-hidden"
    >
        <div class="ppv2-flex ppv2-flex-col ppv2-z-10">
            <h3 class="poppinsSemiBold ppv2-mb-1" :style="{ fontSize: normalizeFontSize(16) }">
                {{ $t('common.enhancement_banner.title') }}
            </h3>
            <p class="poppinsRegular ppv2-text-opacity-70 !ppv2-mb-0" :style="{ fontSize: normalizeFontSize(13) }">
                <span v-html="descriptionContent"></span>
                <a v-if="!customDescription" href="/back-office/helpdesk" class="hover:ppv2-underline">
                    {{ $t('common.enhancement_banner.link') }}
                </a>
            </p>
        </div>

        <div class="ppv2-flex ppv2-items-center ppv2-z-10 ppv2-min-w-max" :style="{ gap: normalizeSize(16, true) }">
            <div class="illustration-wrapper ppv2-flex-shrink-0">
                <img
                    src="/media/svg/availableSoon.svg"
                    :alt="$t('available_soon.image_alt')"
                    class="ppv2-h-16 ppv2-w-16 ppv2-object-contain"
                />
            </div>

            <button
                v-if="showClose"
                @click="$emit('close')"
                class="ppv2-opacity-50 hover:ppv2-opacity-100 ppv2-transition-opacity"
            >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6L18 18" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
import normalizeSize from '../../utils/normalizeSize'
import normalizeFontSize from '../../utils/normalizeFontSize'

export default {
    name: 'EnhancementBanner',
    props: {
        isVisible: {
            type: Boolean,
            default: false,
        },
        showClose: {
            type: Boolean,
            default: false,
        },
        customDescription: {
            type: String,
            default: '',
        },
    },
    computed: {
        descriptionContent() {
            if (this.customDescription) {
                return this.customDescription.replace(/\n/g, '<br>')
            }
            return this.$t('common.enhancement_banner.description')
        },
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
    },
}
</script>

<style scoped lang="scss">
.enhancement-banner {
    background: #021832;

    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow:
        0 4px 6px -1px rgb(0 0 0 / 0.1),
        0 2px 4px -2px rgb(0 0 0 / 0.1);
    h3,
    p,
    a {
        color: #fff !important;
    }
    button svg path {
        stroke: #fff !important;
    }
    &::before {
        content: '';
        position: absolute;
        top: -50%;
        right: -10%;
        width: 300px;
        height: 300px;
        background: radial-gradient(circle, rgba(90, 52, 233, 0.15) 0%, transparent 70%);
        pointer-events: none;
    }
}
.dark {
    .enhancement-banner {
        background: #fff;
        h3,
        p,
        a {
            color: #021832 !important;
        }
        button svg path {
            stroke: #021832 !important;
        }
    }
}
.illustration-wrapper {
    position: relative;
    z-index: 10;
}
</style>
